!(function (n, e) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = e())
    : "function" == typeof define && define.amd
      ? define(e)
      : ((n =
          "undefined" != typeof globalThis
            ? globalThis
            : n || self).EmblaCarouselAutoplay = e());
})(this, function () {
  "use strict";
  const n = {
    active: !0,
    breakpoints: {},
    delay: 4e3,
    instant: !1,
    defaultInteraction: !0,
    stopOnLastSnap: !1,
    rootNode: null,
  };
  function e(t = {}) {
    let o,
      i,
      r,
      u = !1,
      a = !1,
      l = null,
      s = null,
      c = 0,
      f = !1,
      d = !1,
      p = !1,
      m = !1,
      y = !1,
      g = N;
    function v() {
      return !u && !a && o.active;
    }
    function w() {
      if (v())
        if (b()) d = !0;
        else {
          if (!f) {
            i.createEvent("autoplay:play", null).emit();
          }
          (!(function () {
            const { ownerWindow: n } = i.internalEngine().nodeHandler;
            if (!n) return;
            const e = new Date().getTime(),
              t = i.createEvent("autoplay:timerset", { startTime: e });
            (n.clearTimeout(c), (c = n.setTimeout(h, x())), (s = e), t.emit());
          })(),
            (f = !0));
        }
    }
    function E() {
      if (v()) {
        if (f) {
          i.createEvent("autoplay:stop", null).emit();
        }
        (!(function () {
          const { ownerWindow: n } = i.internalEngine().nodeHandler;
          if (!n) return;
          const e = new Date().getTime(),
            t = i.createEvent("autoplay:timerstopped", { stopTime: e });
          (n.clearTimeout(c), (c = 0), (s = null), t.emit());
        })(),
          (f = !1));
      }
    }
    function T() {
      if (b()) return ((d = f), E());
      d && w();
    }
    function b() {
      const { ownerDocument: n } = i.internalEngine().nodeHandler;
      return !!n && "hidden" === n.visibilityState;
    }
    function N(n, e, t) {
      const o = e.type,
        i = t || o;
      ("slidefocus" === i && E(), "pointerdown" === i && E());
    }
    function S(n, e, t) {
      const o = e.type,
        r = t || o;
      ("mouseenter" === r && (m = !0),
        "mouseleave" === r && (m = !1),
        "pointerdown" === r && (y = !0),
        "pointerup" === r && (y = !1));
      i.createEvent("autoplay:interaction", {
        interaction: r,
        originalEvent: e,
        isMouseOver: m,
        isPointerDown: y,
      }).emit();
    }
    function h() {
      const { indexCurrent: n } = i.internalEngine(),
        e = n.clone().add(1).get(),
        t = i.snapList().length - 1,
        r = o.stopOnLastSnap && e === t,
        u = i.createEvent("autoplay:select", {
          targetSnap: i.canGoToNext() ? e : 0,
          sourceSnap: n.get(),
        });
      if (
        (i.canGoToNext() ? i.goToNext(p) : i.goTo(0, p),
        u.emit(),
        (l = null),
        r)
      )
        return E();
      w();
    }
    function x() {
      return l || r[i.selectedSnap()];
    }
    function D() {
      if (!v()) return null;
      if (!s) return null;
      const n = new Date().getTime() - s;
      return x() - n;
    }
    return {
      name: "autoplay",
      options: t,
      init: function (l, s) {
        i = l;
        const { mergeOptions: c, optionsAtMedia: f } = s,
          d = c(n, e.globalOptions),
          m = c(d, t);
        if (((a = !1), (o = f(m)), (u = i.internalEngine().isSsr), !v()))
          return;
        if (i.snapList().length <= 1) return;
        ((p = o.instant),
          (r = (function (n, e) {
            const t = n.snapList();
            return "number" == typeof e ? t.map(() => e) : e(t, n);
          })(i, o.delay)),
          (g = o.defaultInteraction ? N : S));
        const { eventStore: y, nodeHandler: w } = i.internalEngine(),
          { ownerDocument: E } = w,
          b = (function (n, e) {
            const t = n.rootNode();
            return (e && e(t)) || t;
          })(i, o.rootNode);
        (E && y.add(E, "visibilitychange", T),
          i.on("pointerdown", g),
          i.on("pointerup", g),
          i.on("slidefocus", g),
          y.add(b, "mouseenter", (n) => g(i, n, n.type)),
          y.add(b, "mouseleave", (n) => g(i, n, n.type)),
          y.add(i.containerNode(), "focusout", (n) =>
            g(i, n, "slidefocusout"),
          ));
      },
      destroy: function () {
        v() &&
          (i.off("pointerdown", g).off("pointerup", g).off("slidefocus", g),
          E(),
          (a = !0),
          (f = !1));
      },
      play: function (n) {
        ((p = null != n ? n : p), w());
      },
      stop: function () {
        f && E();
      },
      reset: function () {
        f && w();
      },
      pause: function () {
        f && ((l = D()), E());
      },
      isPlaying: function () {
        return f;
      },
      timeUntilNext: D,
    };
  }
  return ((e.globalOptions = void 0), e);
});
